import styled from "styled-components";

export const ProviderCard = styled.div`
  border-radius: 8px;
  background-color: ${(p) => p.theme.background.secondary};
  padding: 1rem 1.25rem;
  margin-bottom: 0.75rem;
`;

export const ProviderCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ProviderCardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ProviderCardActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const WizardStepLabel = styled.p`
  font-size: 0.875rem;
  color: ${(p) => p.theme.text.secondary};
  margin: 0 0 1rem;
`;

export const WizardOptionGroup = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const WizardOptionCard = styled.button<{ $selected?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 1.25rem 1rem;
  border-radius: 8px;
  border: 2px solid
    ${(p) => (p.$selected ? p.theme.text.default : p.theme.background.tertiary)};
  background: ${(p) => p.theme.background.tertiary};
  color: ${(p) => p.theme.text.default};
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 500;
  transition: border-color 0.15s;

  &:hover {
    border-color: ${(p) => p.theme.text.muted};
  }
`;

export const WizardOptionHint = styled.span`
  font-size: 0.8125rem;
  font-weight: 400;
  color: ${(p) => p.theme.text.secondary};
`;

export const WizardFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const WizardReview = styled.dl`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.5rem 1rem;
  margin: 0;
  font-size: 0.875rem;

  dt {
    color: ${(p) => p.theme.text.secondary};
  }

  dd {
    margin: 0;
    word-break: break-all;
  }
`;

export const ProviderCardDetails = styled.dl`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.25rem 1rem;
  margin: 0.75rem 0 0;
  font-size: 0.875rem;

  dt {
    color: ${(p) => p.theme.text.secondary};
  }

  dd {
    margin: 0;
    word-break: break-all;
  }
`;
